import { render, staticRenderFns } from "./LogoPane.vue?vue&type=template&id=2545e1de&scoped=true&"
import script from "./LogoPane.vue?vue&type=script&lang=js&"
export * from "./LogoPane.vue?vue&type=script&lang=js&"
import style0 from "./LogoPane.vue?vue&type=style&index=0&id=2545e1de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2545e1de",
  null
  
)

export default component.exports